"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M3.627 7.5a2 2 0 0 1 2-2H9.26a2 2 0 0 1 1.11.336l1.192.795a2 2 0 0 0 1.11.336H20.6a2 2 0 0 1 2 2v9.2a2 2 0 0 1-2 2H5.627a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.229 6H6.5a2.6 2.6 0 0 0-2.6 2.6v7.8A3.6 3.6 0 0 0 7.5 20h11a3.6 3.6 0 0 0 3.6-3.6v-5.15a3.6 3.6 0 0 0-3.6-3.6h-6.031a3.4 3.4 0 0 1-1.963-.625l-.776-.548A2.6 2.6 0 0 0 8.229 6M6.5 4.6h1.729a4 4 0 0 1 2.309.733l.776.55a2 2 0 0 0 1.155.366H18.5a5 5 0 0 1 5 5v5.15a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V8.6a4 4 0 0 1 4-4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.888 11.517a1.968 1.968 0 1 0 3.936 0 1.968 1.968 0 0 0-3.936 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.7 17.146a2.545 2.545 0 0 1 2.546-2.545h1.798a2.545 2.545 0 0 1 2.545 2.545v.099a.636.636 0 0 1-.636.636H7.337a.636.636 0 0 1-.636-.636zm7.976.735h3.988a.636.636 0 0 0 .636-.636v-.099a2.545 2.545 0 0 0-2.545-2.545h-1.798a2.54 2.54 0 0 0-.992.2 3.73 3.73 0 0 1 .825 2.345v.099c0 .223-.04.438-.114.636"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13 17.88a.636.636 0 0 1-.588-.635v-.099c0-.619.22-1.187.589-1.628.367.441.588 1.009.588 1.628v.099c0 .336-.26.61-.59.634"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.177 11.518a1.968 1.968 0 1 0 3.936 0 1.968 1.968 0 0 0-3.936 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkspacesIcon26.js.map